export function installProjectDataLoader(router, store) {
  let isLoadingData = false;

  router.beforeEach(async (to, from, next) => {
    const requiresCommonData = to.matched.some(
      (record) => record.meta?.requiresCommonData === true
    );

    if (!requiresCommonData) {
      return next();
    }

    if (store.getters["common/isDataLoaded"]) {
      return next();
    }

    try {
      if (!isLoadingData) {
        isLoadingData = true;
        await store.dispatch("common/loadAllData");
      }
    } catch (error) {
      console.error("Error loading common data in route guard:", error);
    } finally {
      isLoadingData = false;
    }

    return next();
  });
}